/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Faq_Q1_AnswerInputs */

const en_home_faq_q1_answer = /** @type {(inputs: Home_Faq_Q1_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At the top of this page, click "Activate Access" to get started in minutes. You will need your policy number and use the email you registered your policy with.`)
};

const fr_home_faq_q1_answer = /** @type {(inputs: Home_Faq_Q1_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En haut de cette page, cliquez sur « Activer l'accès » pour commencer en quelques minutes. Vous aurez besoin de votre numéro de police et de l'adresse courriel avec laquelle vous avez enregistré votre police.`)
};

/**
* | output |
* | --- |
* | "At the top of this page, click \"Activate Access\" to get started in minutes. You will need your policy number and use the email you registered your policy with." |
*
* @param {Home_Faq_Q1_AnswerInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_faq_q1_answer = /** @type {((inputs?: Home_Faq_Q1_AnswerInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Faq_Q1_AnswerInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_faq_q1_answer(inputs)
	return fr_home_faq_q1_answer(inputs)
});